import type { ComponentType, ReactNode } from 'react'

import { formatPhone } from '@/Ship/Helpers/formatPhone'

import { BaseFieldTemplate } from './BaseFieldTemplate'
import { BaseViewFieldTemplate } from './BaseViewFieldTemplate'

// Шаблони ядра/Ship написані на JSX без типів пропсів
const FieldTemplate = BaseFieldTemplate as ComponentType<any>
const ViewFieldTemplate = BaseViewFieldTemplate as ComponentType<any>

interface PhoneFieldTemplateProps {
    field: any
    formContext: any
    /** У редагуванні — інпут, у перегляді ядро передає сире значення поля */
    children?: ReactNode
}

const formatValue = (value: unknown): string => {
    if (Array.isArray(value)) {
        const parts = value.filter((item) => typeof item === 'string' && item !== '').map((item) => formatPhone(item))
        return parts.length > 0 ? parts.join(', ') : '-'
    }
    return typeof value === 'string' && value !== '' ? formatPhone(value) : '-'
}

/**
 * Шаблон поля телефону (`template` у визначенні поля): у перегляді показує номер
 * у форматі +380 (XX) XXX-XX-XX замість сирих цифр, у редагуванні — звичайний шаблон.
 * Через `template`, а не `view`, бо `view` ядро рендерить без лейбла.
 */
export const PhoneFieldTemplate = ({ field, formContext, children }: PhoneFieldTemplateProps) => {
    const isEditable =
        formContext?.isEditable !== false && field?.isEditable !== false && field?.definition?.isEditable !== false
    if (isEditable) {
        return <FieldTemplate field={field}>{children}</FieldTemplate>
    }
    return <ViewFieldTemplate field={field}>{formatValue(children)}</ViewFieldTemplate>
}
